import { render, staticRenderFns } from "./NewPhoto.vue?vue&type=template&id=332b4fa0&scoped=true&"
import script from "./NewPhoto.vue?vue&type=script&lang=js&"
export * from "./NewPhoto.vue?vue&type=script&lang=js&"
import style0 from "./NewPhoto.vue?vue&type=style&index=0&id=332b4fa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332b4fa0",
  null
  
)

export default component.exports